export default "__VITE_ASSET__CN7CTg7T__"